import { BlackjackDealer, BlackjackListener, Secret, secretValueToString } from 'game-logic';

export class RemoteDealer implements BlackjackDealer {
  private readonly blackjackListener: BlackjackListener;
  private cachedDisclosedSecrets: Secret[] = [];

  constructor(blackjackListener: BlackjackListener) {
    this.blackjackListener = blackjackListener;
  }

  public async discloseSecrets(
    indexes: number[],
    gameHash: string,
    existingDeal: boolean,
  ): Promise<string[]> {
    const disclosedSecrets = this.cachedDisclosedSecrets.length;

    // Try and match indexes with cached disclosed secrets first
    const disclosedCards = this.matchDisclosedSecrets(indexes, this.cachedDisclosedSecrets);
    if (disclosedCards.length === indexes.length) {
      return disclosedCards;
    }
    // Get secrets from the cloud
    return await this.fetchSecrets(indexes, gameHash, disclosedSecrets, existingDeal);
  }

  private async fetchSecrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<string[]> {
    const response = await this.blackjackListener.discloseSecrets(
      indexes,
      gameHash,
      disclosedSecrets,
      existingDeal,
    );
    if (response === undefined) {
      return [];
    }
    this.cacheSecrets(response);

    return this.matchDisclosedSecrets(indexes, response);
  }

  private matchDisclosedSecrets(indexes: number[], disclosedSecrets: Secret[]) {
    const matchedSecrets: string[] = [];
    indexes.forEach((index) => {
      for (const secret of disclosedSecrets) {
        if (secret.index === index) {
          matchedSecrets.push(secretValueToString(secret));
          break;
        }
      }
    });
    return matchedSecrets;
  }

  private cacheSecrets(secrets: Secret[]) {
    secrets.forEach((secret) => {
      if (!this.cachedDisclosedSecrets.some((existing) => existing.index === secret.index)) {
        this.cachedDisclosedSecrets.push(secret);
      }
    });
  }
}
